module.exports = __webpack_public_path__ + "media/images/room_menu_icon/contacts-6146ab2106aea468cd825d686e9086b3.png";